import * as api from '../api'

//Action Creators
export const getAllProperties = () => async (dispatch) => {
  try {
    const { data } = await api.fetchAllProperties()
    dispatch({ type: 'FETCH_ALL_PROPERTIES', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error.response.data.message,
    })
  }
}
